new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
            .then(res => {
                const actualElement = event.target;
                if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                    $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                }
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.remove('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.is-selected')?.classList.add('is-selected');
                actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);   
                actualElement.closest('.product__colors-item').classList.add('is-selected');
                actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                var sizes = [];
                for (i = 0; i <= res.data.variations.length - 1; i++) {
                    if (res.data.variations[i].main_attribute != null) {
                        sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                    }
                }
                for (i = 0; i <= sizes.length - 1; i++) {
                    if (sizes[i].main_attribute != null) {
                        var randomNumber = Math.floor(Math.random() * 99999999);
                        var stock = sizes[i].available == false ? 'out-of-stock' : '';
                        actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                    }
                }
                if (res.data.addons.length) {
                    var complements = document.createElement('div');
                    complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                    complements.setAttribute('class', 'complements');
                    complements.setAttribute('complements-for', `${id}`);
                    complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                    for (i = 0; i <= res.data.addons.length - 1; i++) {
                        var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                        var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                        complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                        if (res.data.addons[i].field_type == "radio_options") {
                            var complementsSelect = document.createElement('select');
                            complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                            complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                            for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                            }
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content');
                            $(selectDiv).append(complementsSelect);
                            $(complements).append(selectDiv);
                        } else if (res.data.addons[i].field_type == "text") {
                            var selectDiv = document.createElement('div');
                            selectDiv.setAttribute('class', 'complements-content-area');
                            $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                            $(complements).append(selectDiv);
                        }
                    }
                    $('.kitcolors').closest('.itens-for-carousel').append(complements);
                }
                $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function() {
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);  
                });
                if (window.outerWidth <= 991) {
                    var slickSlider = $('.product-detail__header--photoArea-mobile');

                    if (slickSlider.hasClass('slick-initialized')) {
                        slickSlider.slick('slickRemove', null, null, true);
                    } else {
                        slickSlider.slick();
                    }
                
                    for (i = 0; i < res.data.images.length; i++) {
                        slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                    }
                
                    slickSlider.slick('slickGoTo', 1);
                } else {
                    const noThumbs = document.querySelector('#product-photo');
                    if (noThumbs) {
                        var noThumbsUl = document.querySelector('#product-photo ul');

                        // Remova todos os spans dentro do noThumbsUl
                        while (noThumbsUl.firstChild) {
                            noThumbsUl.removeChild(noThumbsUl.firstChild);
                        }

                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            var li = document.createElement('li');
                            li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                            noThumbsUl.appendChild(li);
                        }
                    } else {
                        $('.sp-wrap').each(function() {
                            $(this).closest('.slick-slide').remove();
                        });
                        for (i = 0; i <= res.data.images.length - 1; i++) {
                            $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                            if (i == 0) {
                                document.querySelector('.sp-wrap').click();
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            let galleryLeft = document.querySelector('.gallery-left');
            let galleryRight = document.querySelector('.gallery-righ');

            if(photoArea && photoThumbs) {
                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if(photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        singlePhotoItem.forEach((content) => {
                            content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }
    
                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                            activeTab(index);
                        });
                    });
                }
            }

            if (galleryLeft && galleryRight) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 5,
                    vertical: true,
                    slidesToScroll: 1
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("kit-variations-div");
            const fixedBuy = document.querySelector(".product-detail__fixed--buy");
            const zoomContainer = document.getElementById("zoom-container");

            if (!buyButton || !fixedBuy) return;

            const rect = buyButton.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            const kitVisible = rect.top < viewportHeight && rect.bottom > 0;
            const kitAboveViewport = rect.bottom <= 0;           // sumiu para cima
            const kitBelowViewport = rect.top >= viewportHeight; // sumiu para baixo

            let zoomVisible = false;
            if (zoomContainer) {
                const zoomRect = zoomContainer.getBoundingClientRect();
                zoomVisible = zoomRect.top < viewportHeight && zoomRect.bottom > 0;
            }

            // Se o zoom estiver visível, nunca mostra o botão flutuante
            if (zoomVisible) {
                fixedBuy.classList.remove("active");
                return;
            }

            // Regras:
            // - Se o kit está visível na tela → esconde botão flutuante
            // - Se o kit sumiu "para baixo" (abaixo do viewport) → esconde botão flutuante
            // - Se o kit sumiu "para cima" (acima do viewport) E zoom não está visível → mostra botão flutuante
            if (kitAboveViewport && !kitVisible && !kitBelowViewport) {
                fixedBuy.classList.add("active");
            } else {
                fixedBuy.classList.remove("active");
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();
        this.checkBuyView();
        window.addEventListener("scroll", this.checkBuyView, { passive: true });

        document.querySelectorAll('figure.brand[data-image-brand]').forEach(function (figure) {
          var url = figure.getAttribute('data-image-brand');
          figure.innerHTML = '<img src="' + url + '" alt="">';
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });

        const vinculoSimilares = document.querySelector('.vinculo-similares-selector');
        const priceArea = document.querySelector('.product-detail__header--infoArea-price');
        if (vinculoSimilares && priceArea) {
            priceArea.appendChild(vinculoSimilares);
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    let navTab = document.querySelector('.product-detail__nav');
    let nav = document.querySelector('.product-detail__nav-tab');
    let navItem = nav ? nav.querySelectorAll('.nav-item') : [];
    let navContent = document.querySelector('.product-detail__nav-content');
    let navShow = navContent ? navContent.querySelectorAll('.nav-show') : [];

    if (navTab && navItem.length === 0) {
        navTab.style.display = 'none';
    }

    if (navTab && navItem.length && navShow.length) {
        navItem = Array.from(navItem);
        navShow = Array.from(navShow);

      navItem[0].classList.add('active');
      navShow[0].classList.add('active');

        function activeTab(index) {
            navShow.forEach((content) => {
                content.classList.remove('active');
            });
            navItem.forEach((item) => {
                item.classList.remove('active');
            });
            navShow[index].classList.add('active');
            navItem[index].classList.add('active');
        }

        navItem.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', () => {
                const isActive = itemMenu.classList.contains('active');

                // Se já estiver ativo, desativa
                if (isActive) {
                    itemMenu.classList.remove('active');
                    navShow[index].classList.remove('active');
                } else {
                    activeTab(index);
                }
            });
        });
    }

    const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail__');
    if (allSizesLabel) {
        allSizesLabel.forEach(label => {
            label.addEventListener('click', () => {
                const inputId = label.getAttribute('for');
                if (inputId) {
                    const container = document.querySelector('.product-detail__fixed--buy');
                    if (container) {
                        const inputsInContainer = container.querySelectorAll('input.clicou');
                        inputsInContainer.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allInputs = document.querySelectorAll('input.clicou');
                    if (allInputs) {
                        allInputs.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allSameInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                    if (allSameInputs) {
                        allSameInputs.forEach(input => {
                            input.classList.add('clicou');
                        })
                    }

                }
            });
        })
    }

    const entregaEl = document.querySelector(".prazo-entrega");
    if (!entregaEl) return;

    const daysEl = entregaEl.querySelector(".prazo-entrega-days");
    if (!daysEl) return;

    const leapDaysAttr = entregaEl.dataset.leapDays;
    const prazoEntregaAttr = daysEl.dataset.prazoEntrega;

    if (!leapDaysAttr || !prazoEntregaAttr) return;

    const leapDays = parseInt(leapDaysAttr, 10);
    const prazoEntrega = parseInt(prazoEntregaAttr, 10);

    if (isNaN(leapDays) || isNaN(prazoEntrega)) return;

    const hoje = new Date();

    // Função para adicionar dias úteis (ignora sábados e domingos)
    function adicionarDiasUteis(data, dias) {
      const novaData = new Date(data);
      let adicionados = 0;

      while (adicionados < dias) {
        novaData.setDate(novaData.getDate() + 1);
        const diaSemana = novaData.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) {
          adicionados++;
        }
      }

      return novaData;
    }

    // Pula se a data final cair num sábado ou domingo
    function pularFimDeSemana(data) {
      const novaData = new Date(data);
      const diaSemana = novaData.getDay();
      if (diaSemana === 6) {
        novaData.setDate(novaData.getDate() + 2); // sábado → segunda
      } else if (diaSemana === 0) {
        novaData.setDate(novaData.getDate() + 1); // domingo → segunda
      }
      return novaData;
    }

    // Meses abreviados
    const mesesAbreviados = [
      "jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
      "jul.", "ago.", "set.", "out.", "nov.", "dez."
    ];

    function formatarData(data) {
      const dia = data.getDate();
      const mes = mesesAbreviados[data.getMonth()];
      return `<b>${dia} de ${mes}</b>`;
    }

    // Calcula datas ignorando finais de semana
    const dataInicio = adicionarDiasUteis(hoje, leapDays);
    const dataFimRaw = adicionarDiasUteis(dataInicio, prazoEntrega);
    const dataFim = pularFimDeSemana(dataFimRaw);

    // Insere no HTML
    daysEl.innerHTML = `${formatarData(dataInicio)} e ${formatarData(dataFim)}`;

    waitForElementToExist('#js-product_attributes__product_detail_ .atributes').then(element => { 
        $('#carrousel-atributes').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
        });
    })

    const productColors = document.querySelector('.product__colors.attribute');
    const itemsPerBatch = 500;
  
    if (productColors) {
      const children = Array.from(productColors.children);
  
      if (children.length > itemsPerBatch) {
        // Ocultar os itens extras
        children.slice(itemsPerBatch).forEach(child => {
          child.style.display = 'none';
        });
  
        // Criar o botão "Ver mais"
        const showMoreButton = document.createElement('button');
        showMoreButton.textContent = 'Ver mais';
        showMoreButton.className = 'btn-show-more';
        productColors.appendChild(showMoreButton);
  
        // Evento para mostrar mais itens
        showMoreButton.addEventListener('click', () => {
          const hiddenItems = children.filter(child => child.style.display === 'none');
          const nextBatch = hiddenItems.slice(0, itemsPerBatch);
  
          nextBatch.forEach(item => {
            item.style.display = '';
          });
  
          // Remover botão se não houver mais itens ocultos
          if (hiddenItems.length <= itemsPerBatch) {
            showMoreButton.remove();
          }
        });
      }
    }

    $("body").on("click", '.minus', function(event) {
        event.preventDefault();
        var $input = $(this).closest('.amount').find('.quantidade');
        var qtd = parseInt($input.val(), 10);
    
        if (qtd > 1) {
            qtd--;
            $input.val(qtd).attr('value', qtd);
        }
    });
    
    $("body").on("click", '.plus', function(event) {
        event.preventDefault();
        var $input = $(this).closest('.amount').find('.quantidade');
        var qtd = parseInt($input.val(), 10);
    
        qtd++;
        $input.val(qtd).attr('value', qtd);
    });

    // Função para verificar se todos os itens do kit têm tamanhos selecionados
    function checkAllKitItemsHaveSizes() {
        const allKitItems = document.querySelectorAll('.itens-for-carousel .product-radio-variation');

        // Verifica se existem itens do kit
        if (!allKitItems || allKitItems.length === 0) {
            return true; // Se não há itens do kit, considera como válido
        }

        let allItemsHaveSizes = true;

        allKitItems.forEach(function (item) {
            const hasVariations = item.getAttribute('data-no-variations');
            if (!hasVariations) {
                // Procura pela variação de rádio no mesmo slide
                const slide = item.closest('.itens-for-carousel');
                const radioVariation = slide.querySelector('.product-radio-variation');
                if (radioVariation) {
                    const checkedInput = radioVariation.querySelector('input[type="radio"]:checked');
                    if (!checkedInput) {
                        allItemsHaveSizes = false;
                    }
                } else {
                    allItemsHaveSizes = false;
                }
            }
        });

        return allItemsHaveSizes;
    }

    // Função para atualizar o estado do botão de compra
    function updateAddToCartButtonState() {
        const addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
        if (addToCartButtons.length > 0) {
            const allItemsHaveSizes = checkAllKitItemsHaveSizes();

            if (allItemsHaveSizes) {
                addToCartButtons.forEach(button => {
                    button.classList.remove('no-buy');
                });
            } else {
                addToCartButtons.forEach(button => {
                    button.classList.add('no-buy');
                });
            }
        }
    }

    // Listener para quando um tamanho é selecionado
    $(document).on('change', '.product-radio-variation input[type="radio"]', function() {
        updateAddToCartButtonState();
    });

    waitForElementToExist('.product__colors.attribute').then(element => {
        $('.product__colors.attribute').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 5,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 7,
                        variableWidth: true,
                    }
                },
            ]
        });
    });
    

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
            768: {
                drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
            addToCartButtons.forEach(button => {
                button.classList.add('no-buy');
            });
            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));
                    
                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });
        
        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        prevArrow: $(".product-list-arrows .prev"),
        nextArrow: $(".product-list-arrows .next"),
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();
});